/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { graphqlEndpoint } from '../utils/globals';
import { firebaseAuth } from '../utils/firebase';

/** function to fetch and return the authorization token */
export const getCurrentUserAuthorizationToken = async (): Promise<string> => {
  if (firebaseAuth && firebaseAuth.currentUser) {
    return `Bearer ${await firebaseAuth.currentUser.getIdToken()}`;
  }
  return '';
};

const authLink = setContext(async (_, { headers }) => {
  // return the headers to the context so httpLink can read them
  const newHeaders = { ...headers };

  newHeaders.authorization = await getCurrentUserAuthorizationToken();

  return {
    headers: newHeaders,
  };
});

const httpLink = createHttpLink({
  uri: graphqlEndpoint,
});

const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      mdsa_sequencing_run: {
        keyFields: ['mdsa_id', 'sr_id'],
      },
    },
  }),
  link: authLink.concat(httpLink),
});

export default client;
